import { useEffect, useState } from "react";
import {
  Link,
} from 'react-router-dom';
import logo from '../assets/images/logo.png';
import ErrorAlert from "../components/ErrorAlert";
import InfoAlert from "../components/InfoAlert";
import SuccessAlert from "../components/SuccessAlert";
import analytics from "../utils/analytics";
import api from "../utils/api";
import store from "../utils/store";


export default function Logout() {

  const [isLoading, setIsLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');

  const handleLogout = async () => {
    try {
      const accessToken = store.getItem('accessToken');
      await api.logout(accessToken);
      analytics.track('Logout');
      store.clear()
    } catch(e) {
      setErrorMsg(e.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      handleLogout();
    }, 1000)
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <Link to='/'>
            <img
              className="mx-auto h-12 w-auto"
              src={logo}
              alt="Unwrangle Logo"
            />
          </Link>
        </div>
      </div>
      <div className="max-w-xl w-full space-y-8 p-10">
        {isLoading ? (
          <div className="animate-pulse">
            <InfoAlert msg={'Logging out...'} />
          </div>
        ) : (
          errorMsg ? (
            <ErrorAlert msg={errorMsg} link={{'path': '/logout', 'text': 'Try Again'}} />
          ) : (
            <SuccessAlert 
              msg='You are now logged out.'
              link={{'path': '/login', 'text': 'Login'}}
            />
          )
        )}
      </div>
    </div>
  )



}